export class ValueType {
  value: any;
  isProcessing = false;
  isDirty = false;
  error: string;
}
